import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import HOME_RUNNER_WORK_REACT_BY_EXAMPLE_REACT_BY_EXAMPLE_PACKAGES_EXAMPLE_PACKAGES_EXAMPLE_PACKAGES_CLASS_BITCOIN_SRC_FC_EXAMPLE_TSX_DEFAULT from '/home/runner/work/react-by-example/react-by-example/packages/example-packages/example-packages/class-bitcoin/src/fc-example.tsx';
import HOME_RUNNER_WORK_REACT_BY_EXAMPLE_REACT_BY_EXAMPLE_PACKAGES_EXAMPLE_PACKAGES_EXAMPLE_PACKAGES_CLASS_BITCOIN_SRC_EXAMPLE_TSX_DEFAULT from '/home/runner/work/react-by-example/react-by-example/packages/example-packages/example-packages/class-bitcoin/src/example.tsx';
import HOME_RUNNER_WORK_REACT_BY_EXAMPLE_REACT_BY_EXAMPLE_PACKAGES_EXAMPLE_PACKAGES_EXAMPLE_PACKAGES_CLASS_SIMPLE_SRC_EXAMPLE_TSX_DEFAULT from '/home/runner/work/react-by-example/react-by-example/packages/example-packages/example-packages/class-simple/src/example.tsx';
import DefaultLayout from "/home/runner/work/react-by-example/react-by-example/packages/gatsby/src/layouts/default.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h2 {...{
      "id": "class-components"
    }}>{`Class Components`}<a parentName="h2" {...{
        "href": "#class-components",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h2>
    <h3 {...{
      "id": "what"
    }}>{`What?`}<a parentName="h3" {...{
        "href": "#what",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h3>
    <ul>
      <li parentName="ul">{`class components used to be the first class citizens`}</li>
      <li parentName="ul">{`has state, props, and lifecycle methods`}</li>
      <li parentName="ul">{`error prone, unless dead simple`}</li>
    </ul>
    <h3 {...{
      "id": "why"
    }}>{`Why?`}<a parentName="h3" {...{
        "href": "#why",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h3>
    <ul>
      <li parentName="ul">{`legacy, mainly`}</li>
      <li parentName="ul">{`please use `}<inlineCode parentName="li">{`FC`}</inlineCode>{` whenever possible`}</li>
      <li parentName="ul">{`migrate class components to `}<inlineCode parentName="li">{`FC`}</inlineCode>{` if possible`}</li>
    </ul>
    <h3 {...{
      "id": "how"
    }}>{`How?`}<a parentName="h3" {...{
        "href": "#how",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h3>
    <ul>
      <li parentName="ul">{`use `}<a parentName="li" {...{
          "href": "https://reactjs.org/docs/faq-functions.html#class-properties-stage-3-proposal",
          "target": "_blank",
          "rel": "noreferrer"
        }}>{`arrow functions`}</a>{` instead of methods `}<a parentName="li" {...{
          "href": "https://reactjs.org/docs/faq-functions.html#why-is-binding-necessary-at-all",
          "target": "_blank",
          "rel": "noreferrer"
        }}>{`(docs)`}</a></li>
    </ul>
    <h4 {...{
      "id": "render"
    }}><inlineCode parentName="h4">{`render`}</inlineCode><a parentName="h4" {...{
        "href": "#render",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h4>
    <ul>
      <li parentName="ul">{`examine `}<inlineCode parentName="li">{`state`}</inlineCode>{` and `}<inlineCode parentName="li">{`props`}</inlineCode>{` -> return JSX`}</li>
      <li parentName="ul">{`MUST BE PURE`}</li>
      <li parentName="ul">{`can’t use hooks 😞`}</li>
    </ul>

      <Example link="https://codesandbox.io/s/8k6ih?file=/src/example.tsx" testLink="https://codesandbox.io/s/p5428?file=/src/example.tsx" code={<>
      <pre {...{
        "className": "grvsc-container dracula",
        "data-language": "tsx",
        "data-index": "0"
      }}><code parentName="pre" {...{
          "className": "grvsc-code"
        }}><span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`import`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` React, { Component, ReactNode } `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`from`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`react`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`export`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`interface`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`CounterProps`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  defaultValue`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`number`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`interface`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`CounterState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  value`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`number`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`export`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`class`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3"
              }}>{`Counter`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`extends`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`Component`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "mtk8 mtki"
              }}>{`CounterProps`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`, `}</span><span parentName="span" {...{
                "className": "mtk8 mtki"
              }}>{`CounterState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`> {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`static`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` defaultProps `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` { defaultValue`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`0`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` }`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  state `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` { value`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.props.defaultValue }`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`decrement`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` ()`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`void`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(({ `}</span><span parentName="span" {...{
                "className": "mtk8 mtki"
              }}>{`value`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` }) `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` ({ value`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` value `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`-`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`1`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` }))`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`increment`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` ()`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`void`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(({ `}</span><span parentName="span" {...{
                "className": "mtk8 mtki"
              }}>{`value`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` }) `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` ({ value`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` value `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`+`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`1`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` }))`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`badIncrement`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`()`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`void`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk4"
              }}>{`// \`this\` is not bound`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(({ `}</span><span parentName="span" {...{
                "className": "mtk8 mtki"
              }}>{`value`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` }) `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` ({ value`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` value `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`+`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`1`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` }))`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  }`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`render`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` ()`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`ReactNode`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`const`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` { value } `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.state`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`return`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` (`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`div`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`type`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`"`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`"`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`onClick`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.decrement}>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`          -`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        </`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`span`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`> {value} </`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`span`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`type`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`"`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`"`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`onClick`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.increment}>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`          +`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        </`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      </`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`div`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    )`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  }`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`export`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`default`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` (`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  <>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    <`}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`Counter`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` />`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    <`}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`Counter`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`defaultValue`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`5`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`} />`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  </>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`)`}</span></span></span></code></pre>
    </>} render={<>
      <>{HOME_RUNNER_WORK_REACT_BY_EXAMPLE_REACT_BY_EXAMPLE_PACKAGES_EXAMPLE_PACKAGES_EXAMPLE_PACKAGES_CLASS_SIMPLE_SRC_EXAMPLE_TSX_DEFAULT}</>


    </>} mdxType="Example" />
    <h4 {...{
      "id": "componentdidmount"
    }}><inlineCode parentName="h4">{`componentDidMount`}</inlineCode><a parentName="h4" {...{
        "href": "#componentdidmount",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h4>
    <ul>
      <li parentName="ul">{`after component rendered to DOM`}</li>
      <li parentName="ul">{`use for:`}<ul parentName="li">
          <li parentName="ul">{`data fetching`}</li>
          <li parentName="ul">{`manipulating DOM`}</li>
        </ul></li>
    </ul>
    <h4 {...{
      "id": "componentdidupdate"
    }}><inlineCode parentName="h4">{`componentDidUpdate`}</inlineCode><a parentName="h4" {...{
        "href": "#componentdidupdate",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h4>
    <ul>
      <li parentName="ul">{`after `}<inlineCode parentName="li">{`state`}</inlineCode>{` or `}<inlineCode parentName="li">{`props`}</inlineCode>{` update`}</li>
      <li parentName="ul">{`usually a copy of `}<inlineCode parentName="li">{`componentDidMount`}</inlineCode></li>
    </ul>
    <h4 {...{
      "id": "setstate"
    }}><inlineCode parentName="h4">{`setState`}</inlineCode><a parentName="h4" {...{
        "href": "#setstate",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h4>
    <ul>
      <li parentName="ul">{`triggers render`}</li>
      <li parentName="ul">{`multiple calls are `}<a parentName="li" {...{
          "href": "https://reactjs.org/docs/state-and-lifecycle.html#state-updates-may-be-asynchronous",
          "target": "_blank",
          "rel": "noreferrer"
        }}>{`batched`}</a></li>
      <li parentName="ul">{`always use `}<inlineCode parentName="li">{`setState`}</inlineCode>{` to update state`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "inline dracula",
          "data-language": "ts",
          "data-index": "0"
        }}><span parentName="code" {...{
            "className": "mtk5 mtki"
          }}>{`this`}</span><span parentName="code" {...{
            "className": "mtk1"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "mtk1"
          }}>{`state`}</span><span parentName="code" {...{
            "className": "mtk1"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "mtk1"
          }}>{`something`}</span><span parentName="code" {...{
            "className": "mtk1"
          }}>{` `}</span><span parentName="code" {...{
            "className": "mtk6"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "mtk1"
          }}>{` `}</span><span parentName="code" {...{
            "className": "mtk11"
          }}>{`'`}</span><span parentName="code" {...{
            "className": "mtk7"
          }}>{`bad`}</span><span parentName="code" {...{
            "className": "mtk11"
          }}>{`'`}</span></code></li>
    </ul>
    <h4 {...{
      "id": "componentwillunmount"
    }}><inlineCode parentName="h4">{`componentWillUnmount`}</inlineCode><a parentName="h4" {...{
        "href": "#componentwillunmount",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h4>
    <ul>
      <li parentName="ul">{`before removing component from DOM`}</li>
      <li parentName="ul">{`use for:`}<ul parentName="li">
          <li parentName="ul">{`freeing resources`}</li>
          <li parentName="ul">{`canceling requests`}</li>
        </ul></li>
    </ul>
    <h4 {...{
      "id": "other-lifecycle-methods"
    }}>{`Other lifecycle methods`}<a parentName="h4" {...{
        "href": "#other-lifecycle-methods",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://reactjs.org/docs/react-component.html",
          "target": "_blank",
          "rel": "noreferrer"
        }}>{`docs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://projects.wojtekmaj.pl/react-lifecycle-methods-diagram/",
          "target": "_blank",
          "rel": "noreferrer"
        }}>{`lifecycle methods cheat sheet`}</a></li>
    </ul>
    <h3 {...{
      "id": "bitcoin-price"
    }}>{`Bitcoin Price`}<a parentName="h3" {...{
        "href": "#bitcoin-price",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h3>

      <Example link="https://codesandbox.io/s/gtrww?file=/src/example.tsx" testLink="https://codesandbox.io/s/2j79n?file=/src/example.tsx" code={<>
      <pre {...{
        "className": "grvsc-container dracula",
        "data-language": "tsx",
        "data-index": "1"
      }}><code parentName="pre" {...{
          "className": "grvsc-code"
        }}><span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`import`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` React, { Component, ReactNode } `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`from`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`react`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`import`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` { BitcoinAPI } `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`from`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`./bitcoin-api`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`export`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`interface`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`BitcoinProps`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`interface`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`BitcoinState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  price`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`number`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`|`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`null`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  fiat`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`gbp`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`|`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`usd`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`export`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`class`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3"
              }}>{`Bitcoin`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`extends`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`Component`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "mtk8 mtki"
              }}>{`BitcoinProps`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`, `}</span><span parentName="span" {...{
                "className": "mtk8 mtki"
              }}>{`BitcoinState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`> {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  state `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` { price`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`null`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`, fiat`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`gbp`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` } `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`as`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`const`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  mounted `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`false`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`componentDidMount`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` ()`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`void`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.mounted `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`true`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`updatePrice`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`()`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  }`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`componentDidUpdate`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` (`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk8 mtki"
              }}>{`prevProps`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`BitcoinProps`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk8 mtki"
              }}>{`prevState`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`BitcoinState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  )`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`void`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`const`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` { fiat } `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.state`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`if`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` (prevState.fiat `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`!==`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` fiat) {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`updatePrice`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`()`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    }`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  }`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`componentWillUnmount`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` ()`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`void`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.mounted `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`false`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  }`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`private`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setGbp`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` () `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`({ fiat`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`gbp`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` })`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`private`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setUsd`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` () `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`({ fiat`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`usd`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` })`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`private`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`getSymbol`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` () `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` ({ gbp`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`£`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`, usd`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` }[`}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.state.fiat])`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`private`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`updatePrice`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`async`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` () `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`({ price`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`null`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` })`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`const`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` { fiat } `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.state`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`const`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` value `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`await`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` BitcoinAPI.`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`getPrice`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(fiat).`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`catch`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(() `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`NaN`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`)`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`if`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` (`}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.mounted) `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`({ fiat, price`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` value })`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  }`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`render`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` ()`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`ReactNode`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`const`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` { price } `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.state`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`return`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` (`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`div`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`type`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`"`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`"`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`onClick`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.setGbp}>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`          £`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        </`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`type`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`"`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`"`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`onClick`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.setUsd}>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`          $`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        </`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`br`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` />`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        {price `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`==`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`null`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`?`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` (`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`          <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`span`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>loading price...</`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`span`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        ) `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` (`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`          <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`span`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`            {`}</span><span parentName="span" {...{
                "className": "mtk5 mtki"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`getSymbol`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`()}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`            {price}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`          </`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`span`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        )}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      </`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`div`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    )`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  }`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`export`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`default`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` <`}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`Bitcoin`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` />`}</span></span></span></code></pre>
    </>} render={<>
      <>{HOME_RUNNER_WORK_REACT_BY_EXAMPLE_REACT_BY_EXAMPLE_PACKAGES_EXAMPLE_PACKAGES_EXAMPLE_PACKAGES_CLASS_BITCOIN_SRC_EXAMPLE_TSX_DEFAULT}</>


    </>} mdxType="Example" />
    <ul>
      <li parentName="ul">{`there is a subtle race-condition above; hard to resolve elegantly`}</li>
      <li parentName="ul">{`cf. `}<inlineCode parentName="li">{`FC`}</inlineCode>{` style below; shorter, simpler & race-condition free`}</li>
    </ul>

      <Example link="https://codesandbox.io/s/gtrww?file=/src/fc-example.tsx" testLink="https://codesandbox.io/s/2j79n?file=/src/fc-example.tsx" code={<>
      <pre {...{
        "className": "grvsc-container dracula",
        "data-language": "tsx",
        "data-index": "2"
      }}><code parentName="pre" {...{
          "className": "grvsc-code"
        }}><span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`import`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` React, { FC, useCallback, useEffect, useMemo, useState } `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`from`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`react`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`import`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` { BitcoinAPI } `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`from`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`./bitcoin-api`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`export`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`const`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`Bitcoin`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`FC`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` () `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`const`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` [fiat, setFiat] `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`useState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`gbp`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`|`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`usd`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>(`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`gbp`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`)`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`const`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` setGbp `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`useCallback`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(() `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setFiat`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`gbp`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`), [])`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`const`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` setUsd `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`useCallback`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(() `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setFiat`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`usd`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`), [])`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`const`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` [price, setPrice] `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`useState`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`number`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`|`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`null`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>(`}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`null`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`)`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`useEffect`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(() `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`let`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` shouldUpdate `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`true`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setPrice`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`null`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`)`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    BitcoinAPI.`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`getPrice`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(fiat)`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      .`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`then`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`((`}</span><span parentName="span" {...{
                "className": "mtk8 mtki"
              }}>{`v`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`) `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` shouldUpdate `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`&&`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setPrice`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(v))`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      .`}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`catch`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(() `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` shouldUpdate `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`&&`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`setPrice`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`NaN`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`))`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`return`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` () `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      shouldUpdate `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`false`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    }`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  }, [fiat])`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`const`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` symbol `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9"
              }}>{`useMemo`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`(() `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=>`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` ({ gbp`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`£`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`, usd`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`'`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` }[fiat]), [fiat])`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`return`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` (`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`div`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`type`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`"`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`"`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`onClick`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`{setGbp}>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        £`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      </`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`type`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`"`}</span><span parentName="span" {...{
                "className": "mtk7"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk11"
              }}>{`"`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk9 mtki"
              }}>{`onClick`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`{setUsd}>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        $`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      </`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`button`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`br`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` />`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      {price `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`==`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk5"
              }}>{`null`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`?`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` (`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`span`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>loading price...</`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`span`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      ) `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` (`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        <`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`span`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`          {symbol}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`          {price}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`        </`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`span`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`      )}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`    </`}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`div`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{`>`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`  )`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk1"
              }}>{`}`}</span></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}></span></span>{`
`}<span parentName="code" {...{
            "className": "grvsc-line"
          }}><span parentName="span" {...{
              "className": "grvsc-source"
            }}><span parentName="span" {...{
                "className": "mtk6"
              }}>{`export`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` `}</span><span parentName="span" {...{
                "className": "mtk6"
              }}>{`default`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` <`}</span><span parentName="span" {...{
                "className": "mtk3 mtki"
              }}>{`Bitcoin`}</span><span parentName="span" {...{
                "className": "mtk1"
              }}>{` />`}</span></span></span></code></pre>
    </>} render={<>
      <>{HOME_RUNNER_WORK_REACT_BY_EXAMPLE_REACT_BY_EXAMPLE_PACKAGES_EXAMPLE_PACKAGES_EXAMPLE_PACKAGES_CLASS_BITCOIN_SRC_FC_EXAMPLE_TSX_DEFAULT}</>


    </>} mdxType="Example" />

    <style {...{
      "className": "grvsc-styles"
    }}>{`
  
  .dracula {
    color: #F8F8F2;
    background-color: #282A36;
  }
  .dracula .mtki { font-style: italic; }
  .dracula .mtk6 { color: #FF79C6; }
  .dracula .mtk1 { color: #F8F8F2; }
  .dracula .mtk11 { color: #E9F284; }
  .dracula .mtk7 { color: #F1FA8C; }
  .dracula .mtk3 { color: #8BE9FD; }
  .dracula .mtk8 { color: #FFB86C; }
  .dracula .mtk5 { color: #BD93F9; }
  .dracula .mtk9 { color: #50FA7B; }
  .dracula .mtk4 { color: #6272A4; }
  .dracula .grvsc-line-highlighted::before {
    background-color: var(--grvsc-line-highlighted-background-color, rgba(255, 255, 255, 0.1));
    box-shadow: inset var(--grvsc-line-highlighted-border-width, 4px) 0 0 0 var(--grvsc-line-highlighted-border-color, rgba(255, 255, 255, 0.5));
  }
`}</style>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      